import { type EditBrandInputType } from '@shelflix/schemas/brand/edit';
import { create } from 'zustand';

interface BrandFormStore {
  formData: Partial<EditBrandInputType>;
  setFormData: (data: Partial<EditBrandInputType>) => void;
  resetForm: () => void;
}

export const useBrandFormStore = create<BrandFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
